import {
  ref, // boolean string integer array
  reactive, // Json หรือ Object
  computed,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
import useModal from '@/@core/components/base-modal/hooks/useModal'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { privilegeExtraPayloadModel } from '@/models/privilege/privilege-form'
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import store from "@/store";
import { EXTRA_PAYLOAD_TYPE } from "@/configs/privilege/privilege";
export default function usePrivilegeExtraPayload(props) {
  const { openModal, closeModal } = useModal()
  const { pagination, onPageChange, onFilterEntity } = usePagination()
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()
  const {
    createForm,
    editForm,
    deleteItemList,
    fetchListData,
    reorderListData,
  } = privilegeExtraPayloadModel()
  const {
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal()
  const {
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const keyChange = ref(0)
  const currentIndex = ref(null);
  const currentIdSelect = ref(null);
  const tableModeReorder = ref(false);

  const loading = reactive({
      tableData: false,
  })

  const formData = reactive({
    privilegeId: 0,
    extrapayloadTable: []
  })

  const extrapayloadDetailItem = reactive({
    privilegeId: 0,
    payloadId: 0,
    data_type: 0,
    key: "",
    value: null
  })

  const fields = reactive({
    extrapayloadTable: [
      { key: 'seq', label: 'No.' },
      { key: 'data_type', label: 'Data Type' },
      { key: 'key', label: 'Key' },
      { key: 'value', label: 'Value' },
      { key: 'actions', label: '' },
    ]
  })
  const isEditExtraPayload = ref(false)


  const modalType = reactive({
    manageExtraPayloadList: false,
  })

  const openExtraPayloadListModal = (itemData,isEdit = false) => {
    isEditExtraPayload.value = false
    if(itemData) {
      extrapayloadDetailItem.payloadId = itemData.payload_id
      extrapayloadDetailItem.data_type = itemData.data_type != 0 ? itemData.data_type : EXTRA_PAYLOAD_TYPE.STRING
      extrapayloadDetailItem.key = itemData.key
      extrapayloadDetailItem.value = resolveValueData(itemData)
    }
     
    if (isEdit == true) {
      isEditExtraPayload.value = true
    }
    extrapayloadDetailItem.privilegeId = formData.privilegeId
    modalType.manageExtraPayloadList = true
    openModal()
  }

  const closeExtraPayloadListModal = () => {
    modalType.manageExtraPayloadList = false
    closeModal()
  }

  const fetchDataList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true
    }

    const payload = {
      Page: pagination.currentPage,
      Limit: pagination.perPage,
      Filters: filters,
      Ordering: [{ Seq: 1, Key: 'priority', Direction: 'desc' }],
      Privilege_Id: formData.privilegeId,
    }

    fetchListData.payload = payload

    store
    .dispatch('api/apiRequest', fetchListData)
    .then(resp => {
      const respData = resp.data
      formData.extrapayloadTable = respData.payload
      pagination.rows = formData.extrapayloadTable.length
      pagination.totalRows = respData ? respData.filtered_record : 0
    })
    .catch(err => {
      openDefaultErrorModal()
    })
    .finally(() => {
      loading.tableData = false
      loading.tableField = false
    })

  };

  const saveExtraPayload = (inputData, isEditModal = false) =>{
    window.$loading(true)
    const payload = {
      Privilege_Id: formData.privilegeId, // required
      Data_type: inputData.data_type,  // required
      Key: inputData.key, // required
      String_Val: null,
      Int_Val: null,
      Decimal_Val: null,
      Bool_Val: true,
      DateTime_Val: null,
      Json_Val: null,
    }

    createForm.payload = payload
    editForm.payload = payload

    let payloadParam = {}

    if (isEditModal) {

      editForm.payload.Payload_Id = inputData.payloadId
      if (inputData.data_type == EXTRA_PAYLOAD_TYPE.STRING){
        editForm.payload.String_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.INT){
        editForm.payload.Int_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.DECIMAL){
        editForm.payload.Decimal_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.BOOL){
        editForm.payload.Bool_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME){
        editForm.payload.DateTime_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.JSON){
        editForm.payload.Json_Val = inputData.value
      }
      payloadParam = editForm

    } else {

      if (inputData.data_type == EXTRA_PAYLOAD_TYPE.STRING){
        createForm.payload.String_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.INT){
        createForm.payload.Int_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.DECIMAL){
        createForm.payload.Decimal_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.BOOL){
        createForm.payload.Bool_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME){
        createForm.payload.DateTime_Val = inputData.value
      } else if (inputData.data_type == EXTRA_PAYLOAD_TYPE.JSON){
        createForm.payload.Json_Val = inputData.value
      }
      payloadParam = createForm

    }
    store
      .dispatch('api/apiRequest', payloadParam)
      .then(resp => {
        modalType.manageExtraPayloadList = false
        closeModal()
        fetchDataList()
      })
      .catch(err => {
        openDefaultErrorModal()
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const openDeleteWarningModal = itemData => {
    openWarningModal(
      'ลบ ExtraPayload',
      `ต้องการลบ ${itemData.key} หรือไม่`,
      () => {
        deleteExtraPayload(itemData.payload_id)
      },
    )
  }

  const deleteExtraPayload = id => {
    window.$loading(true)
    deleteItemList.payload.Privilege_Id = formData.privilegeId // required
    deleteItemList.payload.Payload_Id = id // required

    store
      .dispatch('api/apiRequest', deleteItemList)
      .then(response => {
        openSuccessModal(
          'ทำรายการสำเร็จ !',
          null,
          'ตกลง',
          () => {
            fetchDataList()
          },
          () => {
            fetchDataList()
          },
        )
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const onClickReorder = () => {
    tableModeReorder.value = !tableModeReorder.value;
    sortableRowOptions.disabled = !sortableRowOptions.disabled
  };

  const reorderExtraPayload = async (current, newIndex) => {
    fetchReorderList(currentIdSelect.value, currentIndex.value, newIndex)

    keyChange.value++
    closeModal()
  }

  const handleRowChange = (event) => {
    fetchReorderList(
      formData.extrapayloadTable[event.oldDraggableIndex].payload_id,
      formData.extrapayloadTable[event.oldDraggableIndex].seq,
      formData.extrapayloadTable[event.newDraggableIndex].seq,
    )
    formData.extrapayloadTable.splice(
      event.newDraggableIndex,
      0,
      formData.extrapayloadTable.splice(event.oldDraggableIndex, 1)[0]
    );
    keyChange.value++;
  };

  const fetchReorderList = (id, currentPosition, newPosition) => {
    window.$loading(true)
    loading.tableOverlay = true
    reorderListData.payload.Privilege_Id = formData.privilegeId
    reorderListData.payload.From = currentPosition
    reorderListData.payload.To = newPosition
    reorderListData.payload.Payload_Id = id
    store
      .dispatch('api/apiRequest', reorderListData)
      .then(response => {
        fetchDataList(false)
      })
      .catch(error => {
        openDefaultErrorModal(error)
        loading.tableOverlay = false
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const sortableRowOptions = reactive({
    chosenClass: 'is-selected',
    ghostClass: 'sortable-ghost',
    onEnd: handleRowChange,
    disabled: true,
    animation: 300,
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
  });

  const resolveDataTypeStatus = (status) => {
    switch (status) {
      case 0:
        return "None";
      case EXTRA_PAYLOAD_TYPE.STRING:
        return "String";
      case EXTRA_PAYLOAD_TYPE.INT:
        return "Int";
      case EXTRA_PAYLOAD_TYPE.DECIMAL:
        return "Decimal";
      case EXTRA_PAYLOAD_TYPE.BOOL:
        return "Bool";
      case EXTRA_PAYLOAD_TYPE.DATETIME:
        return "DateTime";
      case EXTRA_PAYLOAD_TYPE.JSON:
        return "Json";
      default:
        return "-";
    }
  };
  
  const resolveClassDataTypeStatus = (status) => {
    switch (status) {
      case 0:
        return "none";
      case EXTRA_PAYLOAD_TYPE.STRING:
        return "string";
      case EXTRA_PAYLOAD_TYPE.INT:
        return "int";
      case EXTRA_PAYLOAD_TYPE.DECIMAL:
        return "decimal";
      case EXTRA_PAYLOAD_TYPE.BOOL:
        return "bool";
      case EXTRA_PAYLOAD_TYPE.DATETIME:
        return "dateTime";
      case EXTRA_PAYLOAD_TYPE.JSON:
        return "json";
      default:
        return "-";
    }
  };

  const resolveValueData = (itemData) => {
    if(itemData.data_type == EXTRA_PAYLOAD_TYPE.STRING){
      return itemData.string_val
    }else if(itemData.data_type == EXTRA_PAYLOAD_TYPE.INT){
      return itemData.int_val
    }else if(itemData.data_type == EXTRA_PAYLOAD_TYPE.DECIMAL){
      return itemData.decimal_val
    }else if(itemData.data_type == EXTRA_PAYLOAD_TYPE.BOOL){
      return itemData.bool_val
    }else if(itemData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME){
      return resolveDate(itemData.datetime_val) + ' ' +  resolveTime(itemData.datetime_val) 
    }else if(itemData.data_type == EXTRA_PAYLOAD_TYPE.JSON){
      return itemData.json_val
    }
  }

  const onSubmitForm = () => {}

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchDataList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchDataList()
    },
    { deep: true },
  )

  onBeforeMount(() => {
    formData.privilegeId = props.privilegeId
    fetchDataList();
  });

  return {
      loading,
      fields,
      formData,
      modalType,
      pagination,
      isEditExtraPayload,
      extrapayloadDetailItem,
      keyChange,
      sortableRowOptions,
      currentIndex,
      tableModeReorder,
      EXTRA_PAYLOAD_TYPE,
      closeModal,
      openExtraPayloadListModal,
      openDeleteWarningModal,
      closeExtraPayloadListModal,
      resolveDataTypeStatus,
      resolveClassDataTypeStatus,
      onSetValueSearch,
      onPageChange,
      onFilterEntity,
      onSubmitForm,
      saveExtraPayload,
      onClickReorder,
      reorderExtraPayload,
      resolveValueData
  }
}
